var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paperplane",
    width: "29px",
    height: "24px",
    viewBox: "0 0 29 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperplane-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperplane-2",
    transform: "translate(-1394.000000, -3024.000000)",
    fill: "#151515",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperplane-3",
    transform: "translate(1080.000000, 2981.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperplane-4",
    transform: "translate(314.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "paperplane-5",
    points: "0.0138095238 23.7272727 29 11.8636364 0.0138095238 0 0 9.22727273 20.7142857 11.8636364 0 14.5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.337d237e23f111b16b844dd043507bcd.svg";
export { ForwardRef as ReactComponent };